import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-1 pl-4"
}
const _hoisted_2 = {
  key: 0,
  class: "col-2"
}
const _hoisted_3 = {
  key: 1,
  class: "col-2"
}
const _hoisted_4 = { class: "col-8" }
const _hoisted_5 = { class: "col-2" }
const _hoisted_6 = {
  key: 0,
  class: "col-2"
}
const _hoisted_7 = {
  key: 1,
  class: "col-2"
}
const _hoisted_8 = { class: "col-8" }
const _hoisted_9 = { class: "col-2" }
const _hoisted_10 = { class: "grid col-12" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "grid col-12" }
const _hoisted_13 = {
  id: "textarea",
  class: "editable-div p-5",
  contenteditable: "true"
}
const _hoisted_14 = {
  key: 1,
  style: {"min-height":"400px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toRecipientsAndBlankRecord, (recipient, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "grid col-12 pt-0 pb-0",
              key: recipient.contactId
            }, [
              (index == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[1] || (_cache[1] = [
                    _createElementVNode("p", { class: "compass-red" }, "To:", -1)
                  ]))]))
                : (_openBlock(), _createElementBlock("div", _hoisted_3)),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_InputText, {
                  type: "text",
                  modelValue: recipient.email,
                  "onUpdate:modelValue": ($event: any) => ((recipient.email) = $event),
                  onChange: ($event: any) => (_ctx.onRecipientEmailChange(this.recipients, recipient,index))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_Button, {
                  icon: "pi pi-trash",
                  onClick: ($event: any) => (_ctx.removeRecipient(this.recipients, index))
                }, null, 8, ["onClick"])
              ])
            ]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ccRecipientsAndBlankRecord, (recipient, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "grid col-12 pt-0 pb-0",
              key: recipient.contactId
            }, [
              (index == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("p", { class: "compass-red" }, "CC:", -1)
                  ]))]))
                : (_openBlock(), _createElementBlock("div", _hoisted_7)),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_InputText, {
                  type: "text",
                  modelValue: recipient.email,
                  "onUpdate:modelValue": ($event: any) => ((recipient.email) = $event),
                  onChange: ($event: any) => (_ctx.onRecipientEmailChange(this.ccRecipients, recipient,index))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_Button, {
                  icon: "pi pi-trash",
                  onClick: ($event: any) => (_ctx.removeRecipient(this.ccRecipients, index))
                }, null, 8, ["onClick"])
              ])
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_10, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "col-2" }, [
              _createElementVNode("p", { class: "compass-red" }, "Subject:")
            ], -1)),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_InputText, {
                type: "text",
                modelValue: _ctx.subject,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.subject) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-2" }, [
              _createElementVNode("p", { class: "compass-red" }, "Attached:")
            ], -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attachedFiles, (file) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "col mt-2 mr-2",
                key: file
              }, [
                _createElementVNode("span", null, _toDisplayString(file), 1)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_13, null, 512), [
      [_vShow, !_ctx.loading]
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createVNode(_component_ProgressSpinner)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}